
import { getData, postData, putData, deleteData } from "../apiClient";

// Get leave applications with pagination
export const getLeaveApplicationsWithPagination = async ({ page = 1, limit = 10, search = '' }, signal = null) => {
    try {
        const queryParams = new URLSearchParams({
            page: String(page),
            limit: String(limit),
            search: search
        });

        const result = await getData(`/leave-application/?${queryParams}`, {}, {}, signal);
        return {
            success: true,
            ...result
        };
    } catch (error) {
        console.error('Get leave applications API error:', error);
        return {
            data: {
                success: false,
                error: error.message,
                data: [],
                totalPages: 1,
                prevPage: false,
                nextPage: false,
                totalDocs: 0,
                page: 1
            }
        };
    }
};

// Get single leave application by ID
export const getLeaveApplicationById = async (id) => {
    try {
        const result = await getData(`/leave-application/${id}`);
        return {
            success: true,
            ...result
        };
    } catch (error) {
        console.error('Get leave application by ID API error:', error);
        return {
            data: {
                success: false,
                error: error.message,
                data: null
            }
        };
    }
};

// Get all employees for selection
export const getAllEmployees = async () => {
    try {
        const result = await getData("/leave-application/employee/all");
        return {
            success: true,
            ...result
        };
    } catch (error) {
        console.error('Get all employees API error:', error);
        return {
            success: false,
            error: error.message,
            data: []
        };
    }
};

// Get all leave types for selection
export const getAllLeaveTypesForApplication = async (applicationYear = null) => {
    try {
        const queryParams = applicationYear ? `?applicationYear=${applicationYear}` : '';
        const result = await getData(`/leave-application/leaveType/all${queryParams}`);
        return {
            success: true,
            ...result
        };
    } catch (error) {
        console.error('Get all leave types API error:', error);
        return {
            success: false,
            error: error.message,
            data: []
        };
    }
};

// Get all supervisors for selection
export const getAllSupervisors = async () => {
    try {
        const result = await getData("/leave-application/supervisor/all");
        return {
            success: true,
            ...result
        };
    } catch (error) {
        console.error('Get all supervisors API error:', error);
        return {
            success: false,
            error: error.message,
            data: []
        };
    }
};

// Get leave stats (total vs enjoyed)
export const getLeaveStats = async (params) => {
    try {
        const queryParams = new URLSearchParams(params);
        const result = await getData(`/leave-application/leave-stats?${queryParams}`);
        return {
            success: true,
            ...result
        };
    } catch (error) {
        console.error('Get leave stats API error:', error);
        return {
            success: false,
            error: error.message,
            data: null
        };
    }
};

// Create new leave application
export const createLeaveApplication = async ({ data }) => {
    try {
        const result = await postData("/leave-application", data, { "Content-Type": "multipart/form-data" });
        return {
            data: {
                success: true,
                data: result,
            },
        };
    } catch (error) {
        console.error("Create leave application API error:", error);
        return {
            data: {
                success: false,
                error: error.status === 400 ? error.data.error : error.message,
                status: error.status,
            },
        };
    }
};

// Update leave application
export const updateLeaveApplication = async ({ id, data }) => {
    try {
        const result = await putData(`/leave-application/${id}`, data, { "Content-Type": "multipart/form-data" });
        return {
            data: {
                success: true,
                data: result,
            },
        };
    } catch (error) {
        console.error('Update leave application API error:', error);
        return {
            data: {
                success: false,
                error: error.status === 400 ? error.data.error : error.message,
                status: error.status,
            },
        };
    }
};

// Delete leave application
export const deleteLeaveApplication = async ({ id }) => {
    try {
        const result = await deleteData(`/leave-application/${id}`);
        return {
            success: true,
            ...result
        };
    } catch (error) {
        console.error('Delete leave application API error:', error);
        return {
            data: {
                success: false,
                error: error.message,
                data: null
            }
        };
    }
};
